import { render, staticRenderFns } from "./nonSTMyocardialInfarction.vue?vue&type=template&id=5dfbd7c2&scoped=true&"
import script from "./nonSTMyocardialInfarction.vue?vue&type=script&lang=js&"
export * from "./nonSTMyocardialInfarction.vue?vue&type=script&lang=js&"
import style0 from "./nonSTMyocardialInfarction.vue?vue&type=style&index=0&id=5dfbd7c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfbd7c2",
  null
  
)

export default component.exports